<template>
    <div v-show="isShow" :style="domStyle" class="Logging">
        <span class="header" ref="mycolor" >
            <Table ref="tables" size="small" class="exportPDF" :loading="loading"  :columns="columns" :data="logData" :disabled-hover="true" :height="tableHeight"></Table>
            <Page :total="dataCount" :current="currentPage" :page-size="pageSize" size="small" class="paging" @on-change="changepage"></Page>
        </span>
    </div>
</template>
<style>
    .paging{
        float:right;
        margin-top:5px;
        white-space: nowrap;
        display:flex;
    }
    .Logging .header {
        --unbgColor : #fff;
        --unColor   : #000;
        --bgColor   : #fff;
        --Color     : #000;
        --thColor :  #f8f8f9;
        --tableColor : #f8f8f9;
        --borderColor : #000;
        --textColor:#000;
        --fontSize:"16px";
        --fontWeight:"normal";
        --fontStyle:"normal";
        --fontFamily:"微软雅黑";
    }
    /* //背景字体 */
    .Logging .header .ivu-table{
        background-color:var(--thColor);
        color:var(--textColor);
        font-size:var(--fontSize);
        font-weight: var(--fontWeight);
        font-style: var(--fontStyle);
        font-family:var(--fontFamily);
    }
    .Logging .ivu-table th,.Logging .ivu-table td{
        background-color:var(--thColor);
        color:var(--textColor);
        font-size:var(--fontSize);
        font-weight: var(--fontWeight);
        font-style: var(--fontStyle);
        font-family:var(--fontFamily);
    }
    
    .Logging .header .ivu-page-next{
        background-color:var(--tableColor);
    }
    .Logging .header .ivu-page-prev{
        background-color:var(--tableColor);
    }
    .Logging .header .ivu-page-item{
        background-color:var(--tableColor);
    }
    .Logging .header  .ivu-table:after{
        background-color:transparent
    }    
    .header  .ivu-table:before{
        background-color:transparent
    }
    .clearfix:before,.clearfix:after {  
        content:"";  
        display:table;  
    }  
    /*用于清除浮动*/ 
    .clearfix:after{  
        clear:both;  
    }  
    .clearfix{  
        *zoom:1;/*IE/7/6*/ 
    }
    /* 边框为其进行隐藏 */
    .Logging .header  .ivu-table-wrapper{
        border:none;
    }
    .Logging .header  .ivu-table th{
        border:none;
    } 
    .Logging .header  .ivu-table td{
        border-color : var(--borderColor);
    }
    .v-transfer-dom .vertical-center-modal{
        z-index: 9999 !important;
    }
    .Logging .header .ivu-spin-fix{
        background-color : var(--bgColor);
    }
</style>
<script>
import Print from 'print-js'
import Vue from "vue";
import { locale, Page } from "view-design";
import cn from "view-design/dist/locale/zh-CN";
import en from "view-design/dist/locale/en-US";
import exportPDF from './exportPDF.js';
export default {
    name : "",
    props : ["primitives","fvSystemApi","parentObject"],
    created(){
        this.defaultTailoring = this.parentObject.defaultTailoring;
        this.windowSize = this.parentObject.windowSize;
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : this.x + "px",
            top : this.y + "px",
            width : this.width + "px",
            height : this.height + "px",
            fontSize:this.fontSize
        };
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5"
        };
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
        if(!this.logType){
            this.UpDateData();
        }
        if (this.$store.state.system.$.languageName == "ch") {
            locale(cn);
        } else {
            locale(en);
        }
        if(this.logFilter.length>0){
            this.logFilter.forEach(element => {
                this.filterTable.push([element.FieldName,element.FieldCondition])
            });
        }
    },
    mounted(){
        this.func();
    },
    data(){
        return {
            loading: false,
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
            columns : [],
            column : [],
            logData : [],
            tableData:[],
            isFilter: false,      // 是否需要过滤数据
            queries:[],           //过滤字段
            queryList:[],
            tableHeight : 0,
            pageSize : 5,
            currentPage : 1 ,          // 当前页数
            dataCount:0,        // 总条数
            nowTime: "",
            filterTable:[],
        }
    },
    methods:{
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e,domScale){},
        /*
            参数：src ：外部属性（对象）
            作用：混淆属性
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            if(this.isEnable) return;
            if(!this.logType) return;
            var curTime = new Date().getTime();
            if(curTime - this.lastTime < this.logstepTime) return;
            this.lastTime = curTime;
            this.UpDateData();
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            if(this.fontSize){
                this.domStyle.fontSize = (12 * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy + "px";  
            }
            this.domStyle.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.domStyle.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + scaleObj.titleHeight + "px";
            this.domStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.domStyle.height =  parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            this.realWidth = parseInt(this.width * (scaleObj.sx + scaleObj.zoom));
            this.tableHeight = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) - 29;
            this.setColumnsData();
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
        },
        /*
            参数：无
            作用：获取当前报警类型
        */
        GetDateLogType(){
            var str = "";
            var backNum 
            if(this.logType){
                str = "最近三天 日志";
                backNum = 1;
            }else{
                str = "历 史 日志";
                backNum = 0;
            }
            return backNum;
        },
        /*
            参数：value 修改的时间
            作用：修改结束时间
        */
        SetEndTime(value){
            this.endTime = value;
        },
        /*
            参数：value 修改的时间
            作用：修改开始时间
        */
        SetStartTime(value){
            this.startTime = value;
        },
        /*
            参数：value 修改的时间间隔
            作用：修改查询间隔
        */
        SetStepTime(value){
            this.logstepTime = value;
        },
        /*
           导出data数据为pdf格式
        */
        exportLoggPDf(name){
            //产生随机字母 
            let ranNum = this.getRanNum();
            //给domo节点添加class
            this.$el.children[0].className +=" "+ranNum;
            // exportPDF.handleWindowPrint(document.querySelector("."+ranNum+" .exportPDF"),name);
            exportPDF.downloadPDF(name,document.querySelector("."+ranNum+" .exportPDF .ivu-table table"),this.columns,this.tableData,this);
            
        },
        //生成随机数
        getRanNum(){
            var result = [];
                for(var i=0;i<4;i++){
                var ranNum = Math.ceil(Math.random() * 25); //生成一个0到25的数字
                    //大写字母'A'的ASCII是65,A~Z的ASCII码就是65 + 0~25;然后调用String.fromCharCode()传入ASCII值返回相应的字符并push进数组里
                    result.push(String.fromCharCode(65+ranNum));
                }
            return  result.join('');
        },
        /*
            参数：value 修改报警类型的值
            作用：切换日志类型
        */
        UpDateLogType(value){
            this.currentPage = 1;
            //切换实时或者历史需要给过滤关闭
            this.isFilter = false;
            //初始化过滤条件
            this.filterTable = [];
            value == "0" ? this.logType = false : this.logType = true;
            // 类型是历史，则手动调用
            if(value == 1){
                this.UpDateData();
            };
        },
        /*
            参数：condition 过滤条件 column 需要过滤的列
            作用：对日志信息进行过滤显示
        */
        LoggingFilter(condition,column){
            //时间需要转换
            
            this.isFilter = true;
            if(column != ""){
                if(!~this.logLayout.findIndex(element => element === column)){
                    this.$Message.info("请核对查询的列是否存在")
                    this.isFilter = false;
                }
            }
            this.filterTable.push([column,condition]);
            //this.UpDateData();
        },
        /*
            参数：无
            作用：打印表单
        */
        Print(){
             if(this.nav()){
                this.$Message.warning("手机以及ipad不支持表单打印!")
            }else{
                this.$Spin.show();
                var columnName = [];
                for(var k in this.jsonData[0]){
                    columnName.push(k);
                }
                Print({
                    printable : this.jsonData,
                    properties : columnName,
                    type: 'json',
                        onLoadingEnd: () => {
                        this.$Spin.hide();
                    }
                })
            }
        },
        /*
            参数：无
            作用：更新数据
        */
        UpDateData(){
            if(this.loading){
                // this.$Message.warning("请求中,请勿重复点击！");
                return;
            };
            
            var data = {}
            if(this.logType){
                let dateTime = this.getDATeTime();
                let his = new Date(dateTime.now).getTime()-259200000;
                let newTime = new Date(dateTime.now).getTime();
                let hisTimes = new Date(his).format("yyyy-MM-dd hh:mm:ss");
                let now = new Date(newTime).format("yyyy-MM-dd hh:mm:ss");
                // 实时
                data = {
                    head: "dataLayer",
                    message: {
                        head: "getOperLogs",
                        message: {
                            "startTime": now,
                            // "endTime": now,
                            "total":parseFloat(this.logsTotal),
                            "filters": this.filterTable,
                            "sorter": ['time', 'desc']
                        }
                    }
                }
            }else{
                // 
                this.loading = true;
                if(this.logFilter.length>0){
                    this.logFilter.forEach(element => {
                        this.filterTable.push([element.FieldName,element.FieldCondition])
                    });
                }
                // 历史
                data= {
                    head: "dataLayer",
                    message: {
                        head: "getOperLogs",
                        message: {
                            "startTime": this.startTime,
                            "endTime": this.endTime,
                            "filters": this.filterTable,
                            "sorter": ['time', 'desc']
                        }
                    }
                }
               
            }
            this.fvSystemApi.getLogData(data).then((result) => {
                this.loading = false;
                // 防止数据不断变化
                // 对获取到的实时数据进行排序
                let sortData = result;
                this.processingData(sortData);
              
            })
            .catch((error) => {
                this.loading = false;
                console.log(error);
            })
        },
        NumAlarmSort(a, b) {
            return b.startTime - a.startTime;
        },
      
        /*------------------------------------脚本在上---------------------------------------------*/
        /*------------------------------------方法在下---------------------------------------------*/
        /*
       /*
       获取当前时间
       */ 
       getDATeTime(){
            var _this = this;
            let yy = new Date().getFullYear();
            let mm = new Date().getMonth()+1;
            let dd = new Date().getDate();
            let hh = new Date().getHours();
            let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
            let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
            return  {
                now:yy+'-'+mm+'-'+dd+' '+hh+':'+mf+":"+ss
            }

	},  
        /*
            参数：index 当前页数
            作用：切换分页
        */  
        changepage(index){
            if(this.temporaryData != undefined){
                this.currentPage = index;
                this.dataCount = this.temporaryData.length;
                var _start = (index - 1) * this.pageSize;
                var _end   = index * this.pageSize;
                var data = this.temporaryData.slice(_start,_end);
                this.tableData=this.temporaryData;
                this.showLogData(data);
            }
        },
        /*
            参数：data 转换为展示数据
            作用：为实时数据的展示进行转换
        */
        processingData(data){
            data.forEach((item) => {
                item.time = this.fvSystemApi.getResource(item.time) || item.time;
                item.oper = this.fvSystemApi.getResource(item.oper) || item.oper;
                item.userName = this.fvSystemApi.getResource(item.userName) || item.userName;
                item.ip = this.fvSystemApi.getResource(item.ip) || item.ip;
                item.params = this.fvSystemApi.getResource(item.params) || item.params;
                item.result = this.fvSystemApi.getResource(item.result) || item.result;
                //doto
            })
            if(this.isFilter){
                var data = this.filterMethod(data);
            }
            this.temporaryData = data;
            var page = Math.floor((this.tableHeight - 32)/40)
            this.pageSize = page > 1 ? page : 1;
            this.changepage(this.currentPage);
        },
        /*
            参数：data 展示用数据
            作用：将数据进行展示
        */
        showLogData(data){
            this.logData = data;
            this.jsonData = JSON.parse(JSON.stringify(data));
            this.disposePrintData(this.jsonData);
        },
        /*
            参数：无
            作用：更新表头
        */
        setColumnsData(){
            if(this.logLayout == null) return  
            this.columns.splice(0);
            this.logLayout.forEach((item) => {
                item = item.split(':');
                let obj = {
                    title : item[0],
                    align : "center",
                    resizable :true,
                };
                //doto
                if(item[0] == "产生时间"){
                    obj.key = 'time';
                    if(!this.adaptiveWidth){obj.width = item[1]};
                };
                if(item[0] == "用户名"){
                    obj.key = "userName";
                    if(!this.adaptiveWidth){obj.width = item[1]};
                };
                if(item[0] == "IP地址"){
                    obj.key = "ip";
                    if(!this.adaptiveWidth){obj.width = item[1]};
                };
                if(item[0] == "操作"){
                    obj.key = "oper";
                    if(!this.adaptiveWidth){obj.width = item[1]};
                };
                if(item[0] == "描述"){
                    obj.key = "params";
                    if(!this.adaptiveWidth){obj.width = item[1]};
                };
                if(item[0] == "结果"){
                    obj.key = "result";
                    if(!this.adaptiveWidth){obj.width = item[1]};
                };
                this.columns.push(obj);
            })
            var tableWidth = 0;
            this.columns.forEach((el) =>{
                tableWidth += el.width; 
            })
            if(tableWidth < this.realWidth){
                this.columns.forEach((el) => {
                    delete el.width;
                })
            }
        },
        /*
            参数：无
            作用：控制class样式绑定为变量
        */
        func(){
            if(this.transparent == 1){
                this.transparent = true;
            }else{
                this.transparent = false;
            }
            var n = 0;
            this.transparent ? n = 0 : n = 1; 
            let fontA,weight;
            if (this.fontStyle == 0 && this.fontWeight == 0) {
                fontA="";weight="";
            } else if (this.fontStyle == 0 && this.fontWeight == 1) {
                fontA="";
                weight="bold";
            } else if (this.fontStyle == 1 && this.fontWeight == 0) {
                fontA="italic";
                weight="";
            } else if (this.fontStyle == 1 && this.fontWeight == 1) {
                fontA="italic";
                weight="bold";
            }
            //背景颜色
            this.$refs.mycolor.style.setProperty("--thColor",this.colorRgba(this.tableBackgroundColor,n));
            //字体颜色
            this.$refs.mycolor.style.setProperty("--textColor",this.tableTextColor);
            this.$refs.mycolor.style.setProperty("--fontSize",this.fontSize);
            this.$refs.mycolor.style.setProperty("--fontStyle",fontA);
            this.$refs.mycolor.style.setProperty("--fontWeight",weight);
            this.$refs.mycolor.style.setProperty("--fontFamily",this.fontName);
            this.$refs.mycolor.style.setProperty("--tableColor",this.transparent ? "transparent" : "#f8f8f9");
            this.$refs.mycolor.style.setProperty("--borderColor",this.borderColor);
        },
        /*
            参数：data 需要过滤的数据
            作用：将数据进行过滤展示
        */
        filterMethod(data){
            var filterData = [];
            if(data.length != 0){
                // 查询固定列
                if(this.queryList.length != ""){
                    data.forEach((item) => {
                        this.columns.forEach((list) => {
                            if(list.title == this.queryList){
                                if(item[list.key].indexOf(this.queries) != -1){
                                    filterData.push(item);
                                }
                            }
                        })
                    })
                }else{
                    // 查询所有列
                    data.forEach((item) => {
                        var overCycle = true;
                        this.columns.forEach((list) => {
                            if(overCycle){
                                if(list.key){
                                    // 把数据转换为字符串
                                    var str = item[list.key] + ""
                                    if(str.indexOf(this.queries) != -1){
                                        filterData.push(item);
                                        overCycle = false;
                                    }
                                }
                            }
                        })
                    })
                }
            }
            return filterData;
        },
        /*
            参数：data 需要转换的数据
            作用：将数据转化为打印格式
        */
        disposePrintData(data){
            var reg = /^[a-zA-Z]+$/;
            data.forEach((item) => {
                this.columns.forEach((list) => {
                    if(list.key){
                        for(var k in item){
                            if(k == list.key){
                                item[list.title] = item[k];
                            }
                        }
                    }
                })
                for(var z in item){
                    if(reg.test(z)){
                        delete item[z];
                    }
                }
            })
        },
        /*
            参数：无
            作用：判断是否支持导出的设备
        */  
        nav(){
            var ua = navigator.userAgent;
            var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
                isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
                isAndroid = ua.match(/(Android)\s+([\d.]+)/),
                isMobile = isIphone || isAndroid;
            if(isIphone || isAndroid || isMobile){
                return true;
            }else{
                return false;
            }
        },
        /*
            参数：str 十六位制颜色 n 透明度
            作用：将十六位制的颜色转为rgba
        */
        colorRgba (str,n){
            if(!str) return;
            //十六进制颜色值的正则表达式
            var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
            var sColor = str.toLowerCase();
            //十六进制颜色转换为RGB格式  
            if(sColor && reg.test(sColor)){  
                if(sColor.length === 4){
                    var sColorNew = "#";  
                    for(var i=1; i<4; i+=1){  //例如：#eee,#fff等
                        sColorNew += sColor.slice(i,i+1).concat(sColor.slice(i,i+1));     
                    }  
                    sColor = sColorNew;  
                }  
                //处理六位颜色值  
                var sColorChange = [];  
                for(var i=1; i<7; i+=2){  
                    sColorChange.push(parseInt("0x"+sColor.slice(i,i+2)));    
                }
                return "rgba(" + sColorChange.join(",") + ","+n+")"; 
            }else{  
                return sColor;    
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/primitives/fvLogging/fvLogging.vue